"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_dom_1 = require("react-router-dom");
var getRoute = function (routes, key, params) {
    var routeDefinition = routes[key];
    return routeDefinition
        ? (0, react_router_dom_1.generatePath)(routeDefinition.path, __assign(__assign({}, routeDefinition.params), params))
        : null;
};
exports.default = getRoute;
